import React from "react";
import classNames from "classnames/bind";
import styles from "./TypingIndicator.module.scss";
const cx = classNames.bind(styles);
export default function TypingIndicator() {
    return (
        <div className={cx("typing-indicator")}>
            <span className={cx("dot")}></span>
            <span className={cx("dot")}></span>
            <span className={cx("dot")}></span>
        </div>
    );
}
